<div class="infos">
  <span class="label">{{label}}</span>
    <form [formGroup]="infosCompsForm">
        <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Observations du service</mat-label>
            <textarea
                [readonly]="!edition_mode"
                type="text" rows="5"
                formControlName="informations_complementaires"
                matInput placeholder="" data-cy=""></textarea>
        </mat-form-field>
    </form>
  <div class="line-action" *ngIf="edition_mode">
    <button mat-raised-button type="button" color="primary"
            [disabled]="!infosCompsForm.dirty"
            matTooltip="Enregistrer les informations complémentaires"
            (click)="saveInfosComps()" data-cy="">
      Enregistrer
    </button>
  </div>

</div>
